import React from 'react';
import RegisterButton from './RegisterButton';

const CallToAction = ({ details }) => {
  if (details.isRegisterButton) {
    return <RegisterButton { ...details } />;
  } else {
    const additionalLinkAttrs = {}
    if(details.openInNewTab) additionalLinkAttrs.target = '_blank'

    return (
      <a href={ details.url } className='btn btn-primary btn-rounded-5' { ...additionalLinkAttrs }>
        { details.label }
      </a>
    );
  }
}

export default CallToAction;